import { createAction, props } from '@ngrx/store';
import { Person } from '@qivos/qivoscloud-ng-api';

export const Token = createAction(
  '[Ms Registration Form]: Token',
  props<{ token: string }>()
);

export const AuthByToken = createAction(
  '[Ms Registration Form]: Auth By Token',
  props<{ token: string }>()
);

export const AuthByTokenSuccess = createAction(
  '[Ms Registration Form]: Auth By Token Success',
  props<{ response: any }>()
);

export const AuthByTokenFailed = createAction(
  '[Ms Registration Form]: Auth By Token Failed',
  props<{ error: string }>()
);

export const searchPersonByTelephone = createAction(
  '[Ms Registration Form]: Search Person By Telephone',
  props<{ mobileNumber: string }>()
);

export const searchPersonByTelephoneSuccess = createAction(
  '[Ms Registration Form]: Search Person By Telephone Success',
  props<{ persons: Person[] | undefined }>()
);

export const searchPersonByTelephoneFail = createAction(
  '[Ms Registration Form]: Search Person By Telephone Failed',
  props<{ message: string }>()
);

export const InitMobileNumber = createAction(
  '[Ms Registration Form]: Initialise Mobile Number',
  props<{ mobileNumber: string }>()
);

export const UpdatePersonData = createAction(
  '[Ms Registration Form]: Update Person Data',
  props<{ person: Person }>()
);

export const UpdatePersonDataSuccess = createAction(
  '[Ms Registration Form]: Update Person Data Success',
  props<{ response: any }>()
);

export const UpdatePersonDataFailed = createAction(
  '[Ms Registration Form]: Update Person Data Failed',
  props<{ error: string }>()
);

export const InitQCCode = createAction(
  '[Ms Registration Form]: Initialise QC Code',
  props<{ qcCode: string }>()
);

export const RedirectToAddToWalletPage = createAction(
  '[Ms Registration Form]: Redirect To Add To Wallet',
  props<{ fName: string; lName: string; cardNumber: string }>()
);

export const RedirectToAddToWalletPageSuccess = createAction(
  '[Ms Registration Form]: Redirect To Add To Wallet Page Success'
);

export const RedirectToAddToWalletPageFailed = createAction(
  '[Ms Registration Form]: Redirect To Add To Wallet Page Failed',
  props<{ error: string }>()
);
